/**
 * We have contracts with some merchants that require that we do not use Generative AI on any of their data.
 *
 * While all AI features should have the ability to be turned off for teams-- this serves as a final safeguard to
 * prevent us from even accidentally using the Redo Agents SDK on their team id.
 *
 * This will throw a very loud error if you ever try to create or use a thread containing a team id that is in this set.
 */
const TEAM_AI_COMPLIANCE_BLACKLIST = new Set<string>([
  "6890dec36d99d3d90659a4a3",
  "6890df432cf991a06c849d25",
]);

export function checkTeamForAIComplianceAndThrow(
  teamId: string,
  agentName: string,
) {
  if (TEAM_AI_COMPLIANCE_BLACKLIST.has(teamId)) {
    throw new Error(
      `[AI Compliance] Team ${teamId} prohibits the use of AI. Agent: ${agentName}`,
    );
  }
}

export function checkTeamForAICompliance(teamId: string): boolean {
  return !TEAM_AI_COMPLIANCE_BLACKLIST.has(teamId);
}
